import {Storage} from "@/services/Storage"
import store from '../store'

export const authentication = {
    async isCashierLoggedIn() {
        const inMemoryUser = store.getters.getCurrentUser;
        const hasInMemoryUser = !!(inMemoryUser && inMemoryUser.Username && String(inMemoryUser.Username).trim().length > 0);
        if (hasInMemoryUser) {
            return true;
        }

        let cashier = await Storage.getCurrentUser()
        const hasValidCashier = !!(cashier && cashier.Username && String(cashier.Username).trim().length > 0);
        if (hasValidCashier) {
            store.commit('setCurrentUser', cashier);
            if (!Array.isArray(store.getters.getUsers) || store.getters.getUsers.length === 0) {
                this.hasUsers().catch(() => false);
            }
            return true;
        }
        return false;
    },

    hasUsers() {
        return Storage.getAllUsers().then(users => {
            const list = Array.isArray(users) ? users : [];
            if (list.length > 0) {
                store.commit('setAllUsers', list);
            }
            return list.length > 0;
        }).catch(() => false);
    },

    /**
     * Franchise Welcome session is valid only when persisted admin has
     * real credentials — empty `{}` after a partial wipe must not count.
     */
    isAdminLoggedIn: async () => {
        let adminUser = await Storage.getAdminUser();
        if (!adminUser || typeof adminUser !== 'object') return false;
        const email = adminUser.email || adminUser.Email || adminUser.username || adminUser.Username;
        const password = adminUser.password || adminUser.Password;
        return !!(
            email && String(email).trim().length > 0 &&
            password && String(password).trim().length > 0
        );
    },

    isStoreSelected() {
        return Storage.getDefaultStore().then((defaultStore) => {
            // Treat missing StoreDB as no selection so a stale nullish
            // row cannot force PIN after store-only sign-out.
            if (defaultStore && defaultStore.StoreDB) {
                store.commit('setDefaultStore', defaultStore)
                return true;
            }
            return false;
        }).catch(() => false)
    },

    isFloatSet(user) {
        return Storage.getFloat().then(res => {
            let userFloat = res.find(f => f.user.toLowerCase() === user.toLowerCase());
            return !!userFloat
        }).catch(() => false)
    },

    async isCurrentUserAdmin() {
        let user = await Storage.getCurrentUser();
        return user.Type.toLowerCase() === 'admin';
    }
}
